<template>
  <div class="border_parent">
    <b-card>
      <b-row type="flex" justify="center">
        <b-col>
          <div class="paper" v-for="item of paperList" :key="item.id">
            <a :href="item.outUrl" target="_blank">
              <span class="paperTitle">{{ item.title }}</span>
            </a>
            <div class="content">{{ item.authors }}</div>
            <div class="content">
              <span class="span_left"
                >{{ item.magazine }} <strong>{{ item.level }}</strong></span
              >
              <span>year: {{ item.year }}</span>
            </div>
            <el-divider></el-divider>
          </div>
        </b-col>
      </b-row>
      <b-row type="flex" :gutter="10" justify="center">
        <b-col>
          <div class="pagination">
            <b-pagination v-model="query.pageNum" :total-rows="total" :per-page="query.pageSize" :limit="3" align="center" size="sm" @input="handleCurrentChange">
              <template v-slot:first-text><span class="text-pag">First</span></template>
              <template v-slot:prev-text><span class="text-pag">Prev</span></template>
              <template v-slot:next-text><span class="text-pag">Next</span></template>
              <template v-slot:last-text><span class="text-pag">Last</span></template>
              <template v-slot:ellipsis-text>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </template>
              <template v-slot:page="{ page, active }">
                <b v-if="active">{{ page }}</b>
                <i v-else>{{ page }}</i>
              </template>
            </b-pagination>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import request from "../utils/request";
export default {
  name: "Paper",
  data() {
    return {
      requestUrl: {
        getPage: "/paper/page",
        baseUrl: "/paper",
      },
      paperList: [],
      query: {
        title: "",
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 获取数据
    getData() {
      request
        .get(this.requestUrl.getPage, {
          params: this.query,
        })
        .then((res) => {
          if (res.code === "200") {
            this.paperList = res.data.records;
            this.total = res.data.total;
          } else {
            this.$message.error("获取失败");
          }
        });
    },

    //修改页
    handleSizeChange(pageSize) {
      this.query.pageSize = pageSize;
      this.getData();
    },
    //修改每页条数
    handleCurrentChange(pageNum) {
      this.query.pageNum = pageNum;
      this.getData();
    },
  },
};
</script>

<style scoped>
h3 {
  color: #333;
  padding: 0;
  margin: 0;
  font-weight: normal;
}

@media (max-width: 1000px) {
  .paperTitle {
    color: #333;
    padding: 0;
    margin: 0;
    font-weight: bold;
    font-size: medium;
    line-height: normal;
  }

  .border_parent {
    width: 100%;
    margin: auto;
  }
}

@media (min-width: 1000px) and (max-width: 1205px) {
  .paperTitle {
    color: #333;
    padding: 0;
    margin: 0;
    font-weight: normal;
    font-size: large;
  }

  .border_parent {
    width: 100%;
    margin: auto;
  }
}

@media (min-width: 1205px) {
  .paperTitle {
    color: #333;
    padding: 0;
    margin: 0;
    font-weight: normal;
    font-size: large;
  }

  .border_parent {
    width: 100%;
    margin: auto;
  }
}

.text-pag {
  color: #002d71;
  font-weight: bold;
}

a {
  text-decoration: none;
}

.paperTitle:hover,
a:hover {
  color: #fbc52c;
}

.paper {
  width: 90%;
  margin: 0 auto;
  font-size: larger;
}

.content {
  margin-top: 8px;
  color: #666;
  font-size: 14px;
}

.span_left {
  margin-right: 10px;
}

/* 修改分隔符样式 */
.el-divider--horizontal {
  margin: 12px 0;
  background: 0 0;
  border-top: 1px dashed #e8eaec;
}
</style>
